import React from 'react';

import App from '../App.js';

export const PublicRouterLayout = ({ children }) => (
  <div className="app sidebar-mini rtl light-theme">{children}</div>
);

export const PrivateRouterLayout = ({ children }) => <App>{children}</App>;
